import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

interface EqxClockProps {
    startTime: string | Date;
    className?: string;
}

const EqxClockInline: React.FC<EqxClockProps> = ({ startTime, className }) => {
    const [tick, setTick] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => setTick(t => t + 1), 1000);
        return () => clearInterval(interval);
    }, [startTime]);

    const getElapsed = () => {
        const start = typeof startTime === 'string' ? new Date(startTime).getTime() : startTime.getTime();
        const now = Date.now();
        const diff = Math.floor((now - start) / 1000);
        const h = Math.floor(diff / 3600);
        const m = Math.floor((diff % 3600) / 60);
        const s = diff % 60;
        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    };

    return <span className={className} style={{ fontFamily: 'monospace' }}>{getElapsed()}</span>;
};

const EqxClock: React.FC<EqxClockProps> = ({ startTime, className }) => {
    return <Card className={className + " text-center bg-light"}>
        <Card.Body className="p-1">
            <EqxClockInline className="text-center fs-1" startTime={startTime} />
        </Card.Body>
    </Card>;
};

export default EqxClock; 